import React from 'react';
import PropTypes from 'prop-types';
import styles from './ConfirmationBlurb.module.scss';

const ConfirmationBlurb = ({
  articleUrl,
  articleTitle,
  submitterEmail,
  licensingContactEmail,
}) => {
  return (
    <p className={styles.blurb}>
      Thank you for purchasing the Licensed Content of{' '}
      <a className={styles['blurb__article-link']} href={articleUrl}>{articleTitle}</a>{' '}
      with Industry Dive.
      <br />
      The purchase confirmation link to the Word Document has been emailed
      to {submitterEmail}. Please direct all licensing questions to{' '}
      <a href={`mailto:${licensingContactEmail}`}>{licensingContactEmail}</a>.
    </p>
  );
};

ConfirmationBlurb.propTypes = {
  articleUrl: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  submitterEmail: PropTypes.string.isRequired,
  licensingContactEmail: PropTypes.string.isRequired,
};

export default ConfirmationBlurb;
